/**
 * The Robustness of the KeySystem.
 *
 * This value is currently only respected by the Widevine KeySystem.
 */
export var Robustness;
(function (Robustness) {
    /**
     * An empty robustness.
     */
    Robustness["EMPTY"] = "EMPTY";
    /**
     * Software crypto
     */
    Robustness["SW_CRYPTO"] = "SW_CRYPTO";
    /**
     * Software decoding
     */
    Robustness["SW_DECODE"] = "SW_DECODE";
    /**
     * Hardware crypto
     */
    Robustness["HW_CRYPTO"] = "HW_CRYPTO";
    /**
     * Hardware decoding
     */
    Robustness["HW_DECODE"] = "HW_DECODE";
    /**
     * Hardware decoding and crypto
     */
    Robustness["HW_ALL"] = "HW_ALL";
})(Robustness || (Robustness = {}));
//# sourceMappingURL=robustness.js.map